import useAuthModal from './useAuthModal';
import UseAuthModalHook from './UseAuthModalHook';

export default UseAuthModalHook;
export { useAuthModal };
